import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/icon_shangchuanS.svg'
import _imports_1 from '@/assets/sound/videoImg.png'
import _imports_2 from '@/assets/sound/retreat.svg'
import _imports_3 from '@/assets/sound/play.svg'
import _imports_4 from '@/assets/sound/pause.svg'
import _imports_5 from '@/assets/sound/forward.svg'
import _imports_6 from '@/assets/sound/reset.png'
import _imports_7 from '@/assets/sound/cut.png'


const _hoisted_1 = { class: "audioInner" }
const _hoisted_2 = { class: "audioInnerUp" }
const _hoisted_3 = {
  key: 0,
  class: "uploadBoxIconBox"
}
const _hoisted_4 = {
  key: 1,
  class: "uploadBoxShow"
}
const _hoisted_5 = { class: "uploadBoxShowInner" }
const _hoisted_6 = { class: "btmInner" }
const _hoisted_7 = { class: "btmInnerBox" }
const _hoisted_8 = { class: "btmInnerBtn" }
const _hoisted_9 = { class: "btmInnerBtnLeft" }
const _hoisted_10 = { class: "btmInnerBtnLeftName" }
const _hoisted_11 = { class: "btmInnerBtnLeftTime" }
const _hoisted_12 = { class: "btmInnerBtnCenter" }
const _hoisted_13 = { class: "btmInnerBtnRight" }
const _hoisted_14 = {
  key: 0,
  class: "btmInnerBtnRightBtn"
}
const _hoisted_15 = {
  key: 1,
  class: "btmInnerBtnRightBtn"
}
const _hoisted_16 = { class: "btmInnerWave" }

import { ref, onMounted,getCurrentInstance,onUnmounted } from 'vue'
import type { UploadInstance, UploadProps, UploadRawFile } from 'element-plus'
import { ElMessage, ElMessageBox, ElSwitch } from "element-plus";
import Auth from "@/api/Auth";
import FetchRequest from "@/api/FetchRequest";
import {
    Close,
} from "@element-plus/icons-vue";
// 时间处理方法
import { timeInfo, timeInfominute } from '@/components/public-method/time-method';
// 音轨引入文件
import WaveSurfer from "wavesurfer.js";
import Timeline from 'wavesurfer.js/dist/plugins/timeline.js';
import Regions, { RegionParams } from 'wavesurfer.js/dist/plugins/regions.js';

export default /*@__PURE__*/_defineComponent({
  __name: 'uploadPage',
  props: {
    isSave: Boolean,
    },
  emits: ['updataFun','errListen','audioChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const upload = ref<UploadInstance>()
const token = Auth.getToken();
let { proxy } = getCurrentInstance();
let wavesurfer: WaveSurfer | null = null;
let wsRegions: Regions = Regions.create() // Regions 实例
// 默认参数
const title=ref('')//上传文件名称
const upFileId=ref('')//上传文件ID
const upUrl=ref('')//上传文件url
// 上传文件
const fileData=ref()//上传文件原始数据
const newFile=ref()//上传文件剪切数据
const isCut=ref(false)//是否显示剪切按钮
const cutSel=ref(false)
const duration=ref(0)//上传文件总时长
const haveFile=ref(false)//是否有上传文件
const isplay=ref(false)
const currentTime=ref(0)
const props = __props
const emit = __emit
const changFile = (file: any,) => {
    console.log('提交上传文件')
    console.log(file)
  
    // if (fileText.value == undefined || fileText.value == '' || fileText.value == null) {
    //     ElMessage.error("请上传文件!");
    //     return
    // }
    upFileId.value=''
    const isLtM = file.raw.size / 1024 / 1024;
    // console.log(isLtM)
    if (isLtM > 20) {
        ElMessage.error("请上传20M以内的文件!");
        return false
    }
    
    fileData.value=file.raw
    title.value=file.name
    haveFile.value=true
    isCut.value=false
    cutSel.value=false
    selAudioChange()
    console.log('===================')
    console.log(URL.createObjectURL(file.raw))
    wavesurfer?.empty()
    wavesurfer?.load(URL.createObjectURL(file.raw));
    wavesurfer?.on('ready', function () {
        currentTime.value=0
        duration.value = Math.ceil(wavesurfer?.getDuration()); // 获取总时长（秒）
        console.log('Total duration:', duration);
    });



   
}
// 重置音轨
const resetFun=()=>{
    if(fileData.value==null || fileData.value==''){
        return
    }
    isCut.value=false
    cutSel.value=false
    wavesurfer?.load(URL.createObjectURL(fileData.value));
    wavesurfer?.seekTo(0, 1)
    wsRegions?.clearRegions()
}
// 提交上传文件
const submiltFile=()=>{
    console.log('提交上传文件')
    if(fileData.value==null || fileData.value==''){
        ElMessage({
            type: 'error',
            message: '请上传音频',
        })
        emit('errListen')
        return
    }
    let file
    if(cutSel.value){
        console.log('上传剪切文件')
        file=newFile.value
    }else{
        console.log('上传原音频')
        file=fileData.value
    }
    const formDatas = new FormData();
    formDatas.append('file',file);
    formDatas.append('businessType','cloneVoice');
    formDatas.append('parentId',0);
    const option = {
        // host: FetchRequest.getHost(),
        method: 'post',
        headers: {
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + token,
        },
        data: {
            access_token: Auth.getToken(),
            name: "file",
        },
        body: formDatas
    };

    fetch(FetchRequest.getHost() + '/ai/voice/file/file', option)
        .then(function (response) {
            if (response.status == 200) {
                return response.json()
            }
        }).then(data=> {
            
            if (data.code == 200) {
                console.log(data)
                if(props.isSave){
                    emit('saveFun',[data.data.fileId,data.data.url])
                }else{
                    emit('listenFun',[data.data.fileId,data.data.url])
                }
                
            } else {
                ElMessage({
                    type: 'error',
                    message: data.msg,
                })
            }
            

        }).catch(err=>{
            emit('errListen')
        })
}
// 加载音轨
onMounted(()=>{
    initWave()
})
const topTimeline = Timeline.create({
  container: '#timeline',
  height: 20,
  insertPosition: 'beforebegin',
  style: {
    fontSize: '10px',
    color: '#848485',
    background:'#1B1D1F'
  },
})

const audioUrl=ref('https://wavesurfer.xyz/wavesurfer-code/examples/audio/audio.wav')
const initWave=()=>{
    console.log('加载音轨')
    wavesurfer = WaveSurfer.create({
            container: document.querySelector('#wavesurferId'),
            waveColor: 'rgba(255, 255, 255, 0.4)',
            progressColor: 'rgba(255, 255, 255, 0.5)',
            cursorColor: 'rgba(255, 255, 255, 1)',
            height: 120,
            cursorWidth: 2,
            // url: audioUrl.value,
            url:proxy.getimgUrlVoice + '/' + audioUrl.value,
            plugins: [topTimeline,wsRegions],
            dragToSeek: true,
            
        });
        wavesurfer?.on('timeupdate', (Time) => {
            // console.log(currentTime)
            currentTime.value=Math.ceil(Time)
        })   
        wavesurfer?.on('finish', function() {
            console.log('播放完成！');
            isplay.value=false
           
        });     
}
// 裁剪
const startTimeInput=ref(0)
const endTimeInput=ref(0)
let cutAudioBlob = null;
let audioBlob = null;
let activeRegion = null
const trimFun=()=>{
    startTimeInput.value=0
    isCut.value=true
    endTimeInput.value=(duration.value/4).toFixed(0)
        wsRegions.addRegion({
            start: startTimeInput.value,
            end: endTimeInput.value,
            content: (endTimeInput.value-startTimeInput.value).toFixed(0)+'S',
            color: 'rgba(76,114,68,0.2)',
            drag: true,
            resize: true,
        })

        wsRegions.on('region-updated', (region) => {
            console.log('Updated region', region)
            startTimeInput.value = region.start.toFixed(0);
            endTimeInput.value = region.end.toFixed(0);
            let str=region.element.querySelector("[part='region-content']")
            str.innerHTML=(endTimeInput.value-startTimeInput.value).toFixed(0)+'S'
        })


        
        wsRegions.on('region-in', (region) => {
            console.log('region-in', region)
            activeRegion = region
        })
        wsRegions.on('region-out', (region) => {
            console.log('region-out', region)
            if (activeRegion === region) {
                if (isCut.value) {
                    region.play()
                } else {
                    activeRegion = null
                }
            }
        })
}
// 确认裁剪
const  trimOk=()=> {
    const startTime = parseFloat(startTimeInput.value);
    const endTime = parseFloat(endTimeInput.value);
    
    if (isNaN(startTime) || isNaN(endTime) || startTime >= endTime) {
        alert('请输入有效的开始和结束时间');
        return;
    }
    
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const reader = new FileReader();
    
    reader.onload = async function(event) {
        try {
            const audioData = event.target.result;
            const audioBuffer = await audioContext.decodeAudioData(audioData);
            
            // 创建新的 AudioBuffer 用于存储剪切后的音频
            const channels = audioBuffer.numberOfChannels;
            const sampleRate = audioBuffer.sampleRate;
            const startOffset = Math.floor(startTime * sampleRate);
            const endOffset = Math.floor(endTime * sampleRate);
            const frameCount = endOffset - startOffset;
            
            const newAudioBuffer = new AudioBuffer({
                length: frameCount,
                numberOfChannels: channels,
                sampleRate: sampleRate
            });
            
            // 复制音频数据
            for (let i = 0; i < channels; i++) {
                const channelData = audioBuffer.getChannelData(i);
                const newChannelData = newAudioBuffer.getChannelData(i);
                for (let j = 0; j < frameCount; j++) {
                    newChannelData[j] = channelData[startOffset + j];
                }
            }
            
            // 导出为 WAV 文件
            const blob = await bufferToWave(newAudioBuffer, frameCount);
            cutAudioBlob = blob;
            newFile.value=new File([blob], title.value)
            selAudioChange()
           
            // 创建预览
            const audioUrl = URL.createObjectURL(blob);
            cutSel.value=true
           
            wavesurfer?.load(audioUrl);
            // initPreviewWavesurfer(audioUrl);
            
            // 显示预览区域
            // previewSection.style.display = 'block';
            
        } catch (error) {
            console.error('音频剪切错误:', error);
            alert('音频剪切失败，请重试');
        }
    };
    

    reader.readAsArrayBuffer(fileData.value);
    // 重置音轨
    wavesurfer?.seekTo(0, 1)
    wsRegions?.clearRegions()
    isCut.value=false
}
// 取消
const trimNo=()=>{
    isCut.value=false
    cutSel.value=false
    newFile.value=fileData.value
    wsRegions?.clearRegions()
}
// 清除音频
const clearFile=()=>{
    haveFile.value=false
    fileData.value=null
    title.value=''
    toPause()
    selAudioChange()
}
// 将 AudioBuffer 转换为 WAV 格式的 Blob
async function bufferToWave(buffer, len) {
    const numOfChan = buffer.numberOfChannels;
    const length = len * numOfChan * 2 + 44;
    const bufferArray = new ArrayBuffer(length);
    const view = new DataView(bufferArray);
    const channels = [];
    
    let sampleRate = buffer.sampleRate;
    let bytesPerSample = 2;
    let blockAlign = numOfChan * bytesPerSample;
    
    // WAV 头部
    writeString(view, 0, 'RIFF');
    view.setUint32(4, length - 8, true);
    writeString(view, 8, 'WAVE');
    writeString(view, 12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, numOfChan, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * blockAlign, true);
    view.setUint16(32, blockAlign, true);
    view.setUint16(34, bytesPerSample * 8, true);
    writeString(view, 36, 'data');
    view.setUint32(40, length - 44, true);
    
    // 写入音频数据
    for (let i = 0; i < numOfChan; i++) {
        channels.push(buffer.getChannelData(i));
    }
    
    let offset = 44;
    let pos = 0;
    
    while (pos < len) {
        for (let i = 0; i < numOfChan; i++) {
            let sample = Math.max(-1, Math.min(1, channels[i][pos]));
            sample = (0 < sample) ? sample * 32767 : sample * 32768;
            view.setInt16(offset, sample, true);
            offset += 2;
        }
        pos++;
    }
    
    return new Blob([bufferArray], { type: 'audio/wav' });
}
// 写入字符串到 DataView
const writeString=(view, offset, string) =>{
    for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
    }
}
// 播放
const toPlay=()=>{
    wavesurfer?.play()
    isplay.value=true
}
const toPause=()=>{
    wavesurfer?.pause()
    isplay.value=false
}
// 快进，后退
const skipFor=()=>{
    wavesurfer?.skip(6)
}
const skipBack=()=>{
    wavesurfer?.skip(-6)
}
// 判断上传音频是否改变
const selAudioChange=()=>{
    emit('audioChange')
}
__expose({
    submiltFile,
})


return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "upLoadBox",
    style: _normalizeStyle(haveFile.value?{'padding-bottom':'20.2rem'}:'')
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"audioInnerTitle\" data-v-61ca81b4><div class=\"titleTop\" data-v-61ca81b4><span data-v-61ca81b4>格式要求</span></div><div class=\"titleRow\" data-v-61ca81b4><span data-v-61ca81b4>时长要求：上传音频的时长需在10-300</span><span class=\"line\" data-v-61ca81b4></span><span data-v-61ca81b4>文件要求：上传音频文件大小需不超过 20mb</span></div><div class=\"titleRow\" data-v-61ca81b4><span data-v-61ca81b4>上传音频中有且只有一个人声，请尽量保持上传音频的音质和背景干净</span></div></div>", 1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          drag: "",
          "show-file-list": false,
          multiple: "",
          "auto-upload": false,
          onChange: changFile,
          accept: ".wav,.mp3"
        }, {
          default: _withCtx(() => [
            (title.value=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
                  _createElementVNode("div", { class: "uploadBoxIcon" }, [
                    _createElementVNode("div", { class: "iconBox" }, [
                      _createElementVNode("div", { class: "iconInner" }, [
                        _createElementVNode("img", { src: _imports_0 })
                      ]),
                      _createElementVNode("div", { class: "iconInnerText" }, [
                        _createElementVNode("div", { class: "iconInnerTextTop" }, "点击或拖拽 音文件 到这里上传"),
                        _createElementVNode("div", { class: "iconInnerTextBtm" }, "最大支持 20 M文件上传")
                      ])
                    ])
                  ], -1)
                ])))
              : _createCommentVNode("", true),
            (title.value!='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[1] || (_cache[1] = _createElementVNode("img", { src: _imports_1 }, null, -1)),
                    _createElementVNode("span", null, _toDisplayString(title.value), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(title.value), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)(currentTime.value*1000)), 1),
              _cache[3] || (_cache[3] = _createTextVNode(" / ")),
              _createElementVNode("span", null, _toDisplayString(_unref(timeInfominute)(duration.value*1000)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              src: _imports_2,
              onClick: _withModifiers(skipBack, ["stop"])
            }),
            _withDirectives(_createElementVNode("img", {
              src: _imports_3,
              onClick: _withModifiers(toPlay, ["stop"])
            }, null, 512), [
              [_vShow, !isplay.value]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: _imports_4,
              onClick: _withModifiers(toPause, ["stop"])
            }, null, 512), [
              [_vShow, isplay.value]
            ]),
            _createElementVNode("img", {
              src: _imports_5,
              onClick: _withModifiers(skipFor, ["stop"])
            })
          ]),
          _createElementVNode("div", _hoisted_13, [
            (!isCut.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("img", {
                    src: _imports_6,
                    onClick: _withModifiers(resetFun, ["stop"])
                  }),
                  _createElementVNode("img", {
                    src: _imports_7,
                    onClick: _withModifiers(trimFun, ["stop"])
                  })
                ]))
              : _createCommentVNode("", true),
            (isCut.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("span", {
                    onClick: _withModifiers(trimOk, ["stop"]),
                    class: "trimBtnYes"
                  }, "修剪"),
                  _createElementVNode("span", {
                    class: "trimBtnNo",
                    onClick: _withModifiers(trimNo, ["stop"])
                  }, "取消")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "closeWave",
            onClick: _withModifiers(clearFile, ["stop"])
          }, [
            _createVNode(_component_el_icon, { color: "#969FA1" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Close))
              ]),
              _: 1
            })
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", {
            id: "timeline",
            class: "wavesurfertimeInner"
          }, null, -1)),
          _cache[5] || (_cache[5] = _createElementVNode("div", {
            id: "wavesurferId",
            class: "wavesurferInner"
          }, null, -1))
        ])
      ])
    ], 512), [
      [_vShow, haveFile.value]
    ])
  ], 4))
}
}

})